import api from "./api";

import { NuevoReclamoPasaje } from "src/utils/interfaces";

// Reembolso de Pasajes: traslados PS->PS detectados por marcaciones.
// El calculo y la gestion viven en EMSYS; aca solo se listan los propios
// y se pueden reclamar traslados faltantes.
export default {
  // Traslados agrupados por mes (+ reclamos propios), filtrados por rango de
  // fechas 'YYYY-MM-DD'. Sin parametros el backend usa la semana actual y la anterior.
  async getReembolsos(desde?: string, hasta?: string) {
    const params: Record<string, string> = {};
    if (desde) params.desde = desde;
    if (hasta) params.hasta = hasta;
    return api.get("reembolsos/pasajes/todos", { params });
  },

  async getDetalle(id: number) {
    return api.get(`reembolsos/pasajes/detalles/${id}`);
  },

  async getConfig() {
    return api.get("reembolsos/pasajes/config");
  },

  // Buscador de PS para el formulario de reclamo (min. 2 caracteres).
  async buscarPS(q: string) {
    return api.get("reembolsos/pasajes/ps", { params: { q } });
  },

  async crearReclamo(payload: NuevoReclamoPasaje) {
    return api.post("reembolsos/pasajes/reclamar", payload);
  },
};
